import { SelectOption } from '~/components/component-library/types'

export const optionText = <ValueType>(option: SelectOption<ValueType>) =>
  option.textValue ?? (typeof option.label === 'string' ? option.label : '')

// Underscores count as spaces so "los angeles" finds "America/Los_Angeles".
const normalize = (text: string) =>
  text
    .toLowerCase()
    .replace(/[_\s]+/g, ' ')
    .trim()

export const matchesQuery = ({
  text,
  query,
}: {
  text: string
  query: string
}) => normalize(text).includes(normalize(query))
